import * as React from 'react'

export * as coffee from './collections/Coffee'
export * as colored from './collections/Colored'
export * as crowdfunding from './collections/Crowdfunding'
export * as currencies from './collections/Currencies'
export * as decoration from './collections/Decoration'
export * as fill from './collections/Fill'
export * as paymentMethods from './collections/PaymentMethods'
export * as stroke from './stroke'
export * as thirdParty from './thirdParty'
export * as twoToned from './collections/TwoToned'

import { SpecificIconProps } from './types'
export { type SpecificIconProps } from './types'

export { SvgSpritesheet } from './SvgSpritesheet'

export type IconElement = React.FunctionComponent<SpecificIconProps>

export * from './Currency'
export * from './Icon'
export * from '../InlineSvg'
export * from '../SizedSvg'
